export default __webpack_public_path__ + "static/media/B_Nadine.a36e3cab.jpg";